export type AvailabilityInfo = {
  activityType: string;
  asSoonAsText: string;
  daysToAvailability: number;
  drivingMiles: number;
  isRestrictedLocation: boolean;
  localTimeZone: string;
  locationCity: string;
  locationState: string;
  routeId: string;
  secondsUntilCutoff: number;
  utcSoonestDateTimeIso: string;
};

export enum InventoryTypeId {
  Core = 1,
  WIP = 2,
  ThirdParty = 3,
  DealerMarketplace = 4
}

export interface VehiclePrice {
  total: number;
  totalDiscountAmount: number;
  discounts: { type: string; amount: number }[];
  monthlyPayment: number;
  downPayment: number;
  downPaymentDetails: {
    totalCashDue: number;
    additionalCashDown: number;
    nonRefundableShippingFees: number;
    tradeDown: number;
  };
  apr: number;
  term: number;
  transportCost: number;
  pricingErrorMessage?: string;
}

export interface MatchedFinance {
  downPayment?: number;
  monthlyPayment?: number;
}

export interface VehicleTag {
  tagId: number;
  tagCategoryId: number;
  tagKey: string;
  tagName: string;
  tagDescription: string;
  isResultTileDisplayable: boolean;
}

export interface Vehicle {
  stockNumber: number;
  vehicleId: number;
  make: string;
  model: string;
  trim: string;
  kbbTrim: string;
  color: string;
  mileage: number;
  price: VehiclePrice;
  year: number;
  isFavorite?: boolean;
  imageUrl: string;
  largeImageUrl: string;
  entireDashImageUrl?: string;
  passengerSeatImageUrl: string;
  infotainmentImageUrl: string;
  steeringImageUrl: string;
  backSeatImageUrl?: string;
  trunkImageUrl: string;
  textlessUrl: string;
  jellyBeanDesktopUrl: string;
  jellyBeanMobileUrl: string;
  isOnDemand: boolean;
  isPurchasePending: boolean;
  daysUntilAvailable?: number;
  earliestDaysToDelivery?: number;
  earliestDeliveryDate?: string;
  earliestDaysToPickup?: number;
  earliestPickupDate?: string;
  vehicleInventoryType: InventoryTypeId;
  vehicleLockType: number;
  vehicleUnlockDateTime?: string;
  addedToCoreInventoryDateTime?: string;
  vdpSlug: string;
  locationId: number;
  stockRecallStatusType: number;
  vin: string;
  vehicleTags: VehicleTag[];
  matchedTerms?: string[];
  matchedFilters: {
    bodyStyles?: string;
    color?: string;
    cylinderCounts?: string;
    driveTypes?: string;
    features?: string[];
    finance?: MatchedFinance;
    fuelTypes?: string;
    mileage?: string;
    modelIds?: string;
    price?: string;
    transmissions?: string;
    trims?: string;
    year?: string;
  };
  missingFilters: object; // find types for missing filters
  storeKey: string;
  vehiclePurchaseType?: string;
  transportCost: number;
  pickupInfo?: AvailabilityInfo;
  deliveryInfo?: AvailabilityInfo;
}
